import React from 'react';
import PropTypes from 'prop-types';
import {
    Drawer,

    FormGroup,
 

    Row,
    Col,
    Panel,
    InputGroup,

    Input,
    Icon,
    Tooltip,
    Whisper

} from 'rsuite';

import {  lettersNumbersDashesSpacesInputMask } from '../../../resources/logic/inputMasks';

import RTable from '../../componentsGeneral/Rsuite/Table/RTable';
import AddToLoadHawbDataElements from '../../dataComponentsXdock/AddToLoadHawbDataElements';
import { zIndex } from 'material-ui/styles';


const styles = {
    width: '100%'
};


const tooltipSearch = (
    <Tooltip>
        Search
    </Tooltip>
);

const tooltipClear = (
    <Tooltip>
        Clear
    </Tooltip>
);


function limitNumberToExistingValue(e, item) {
    try {
        var limitValue = item['RecoveredPCS'] - item['LoadedPCS']
    }
    catch (e) {
        var limitValue = 0
    }
    if (e.target.value <= limitValue) {
        return e.target.value
    }
    else {
        window.alert('Must not be greater than ' + limitValue.toString())
        return limitValue
    }
 
}

const mountRef = React.createRef();

const AddToLoadDrawer = ({ onClickAdd,
    onChange,
 

    placement,
    close,
    handleSortColumn,
    sortColumn,
    sortType,
    tableIdCol,
    onClickSearch,
    onClickReset,
    state,
    ...props }) => (

    <Drawer show={state.showBuildLoadDrawer} onHide={close} placement={placement} style={props.isMobile ? { width: '350px', zIndex:'999999999' } : {paddingLeft: '50px', width: '100%', zIndex:'999999999'}}    >
        <Drawer.Header>
            <Drawer.Title>Add To Load</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body > <div ref={mountRef}> 

            <Panel bordered style={{ marginBottom: '15px' }}>
                <Row>
                    <Col md={24} sm={24}>
                        <FormGroup >


                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>House:</InputGroup.Addon>
                                <Input defaultValue={state.HouseSearch} onChange={(e) => { onChange(e, 'HouseSearch') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />

                                <Whisper placement="top" trigger="hover" speaker={tooltipClear}>
                                    <InputGroup.Button onClick={(e) => { onClickReset(e, 'HouseSearch') }}>
                                        <Icon icon="close" />
                                    </InputGroup.Button>
                                </Whisper>

                                <Whisper placement="top" trigger="hover" speaker={tooltipSearch}>
                                    <InputGroup.Button onClick={(e) => { onClickSearch(e, 'HouseSearch') }}>
                                        <Icon icon="search" />
                                    </InputGroup.Button>
                                </Whisper>
                            </InputGroup>

                            <InputGroup style={{ marginBottom: '15px', width: '100%' }}>
                                <InputGroup.Addon>Master:</InputGroup.Addon>
                                <Input defaultValue={state.MasterSearch} onChange={(e) => { onChange(e, 'MasterSearch') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />

                                <Whisper placement="top" trigger="hover" speaker={tooltipClear}>
                                    <InputGroup.Button onClick={(e) => { onClickReset(e, 'MasterSearch') }}>
                                        <Icon icon="close" />
                                    </InputGroup.Button>
                                </Whisper>

                                <Whisper placement="top" trigger="hover" speaker={tooltipSearch}>
                                    <InputGroup.Button onClick={(e) => { onClickSearch(e, 'MasterSearch') }}>
                                        <Icon icon="search" />
                                    </InputGroup.Button>
                                </Whisper>
                            </InputGroup>

                        </FormGroup>
                    </Col>
                </Row>
            </Panel>


            {RTable(
                props.HawbData,        // tableData,
                AddToLoadHawbDataElements,  // DataElements,
                sortColumn,                 // sortColumn,
                sortType,                   // sortType,
                props.isHawbLoading,         // loading,
                handleSortColumn,      // handleSortColumn,
                null,        // onClickDetails,
                false, // checkColEntry,
                tableIdCol,                 // keyColumn,
                null,                       // checkedKeys,
                null,                       // handleCheckAll,
                null,                       // handleCheck,
                true,                      // boolSelectButton,
                onClickAdd,     // onClickSelect,
                'Add',                       // selectButtonText,
                props.isMobile,        // isMobile,
                props.history,         // history,
                null                        // highlightRowKey
            )}



        </div> </Drawer.Body> 
        <Drawer.Footer>

            <br />

        </Drawer.Footer>
    </Drawer>
);



export default AddToLoadDrawer;
















